import React from 'react';
import { AlertTriangleIcon } from 'lucide-react';
import { Countdown } from './ui/Countdown';
export function UrgencySection() {
  return <section className="bg-background text-center text-foreground" aria-label="Limited time offer" data-id="element-246" data-mp="2sk46nkhn1yb1">
      <div className="h-1 w-full bg-accent" aria-hidden="true" data-id="element-247" data-mp="36bimxjk5vlee" />
      <div className="mx-auto max-w-3xl px-4 py-12" data-id="element-248" data-mp="31iz9qnpdysa4">
        <p className="inline-flex items-center gap-2 text-sm font-bold uppercase tracking-[.16em] text-accent" data-id="element-249" data-mp="31h4rjh5i1e9q">
          <AlertTriangleIcon className="h-4 w-4" aria-hidden="true" data-id="element-250" data-mp="3b910jn94iosq" /> Launch pricing ends in:
        </p>
        <Countdown className="mt-5" data-id="element-251" data-mp="3p8tppe504wyl" />
        <p className="mt-7 font-bold text-muted" data-id="element-252" data-mp="3p7sb4zos1sc4">After that the price increases and never drops again.</p>
      </div>
      <div className="h-1 w-full bg-accent" aria-hidden="true" data-id="element-253" data-mp="3l7q5ygju2gs3" />
    </section>;
}